import { ref } from 'vue'
import axios from 'axios'
import { deeplyCamelize } from 'convert-cases'
import { useFlash } from 'src/biz_spa/composables'
import type { Store } from 'src/biz_spa/types'

type HashTag = {
  id: number
  content: string
}
type Account = {
  id: number
  username: string
  picture: {
    url: string
  }
  name: string
}
type InstagramHashTagSetting = {
  id: number
  businessAccount: Account
  hashTags: HashTag[]
  stores: Store[]
}

export const useGetInstagramHashTagSetting = () => {
  const data = ref<InstagramHashTagSetting>()
  const isLoading = ref<boolean>(false)
  const { updateFlash } = useFlash()

  const readInstagramHashTagSetting = async (companyUuid: string, hashTagSettingId: number) => {
    if (isLoading.value) return

    isLoading.value = true
    await axios.get(`/api/companies/${ companyUuid }/sns/facebook/instagram_business_accounts/hash_tag_settings/${ hashTagSettingId }`)
      .then(res => {
        data.value = deeplyCamelize(res.data.data)
      })
      .catch(err => {
        updateFlash({ type: 'alert', message: err.response.data.errors[0].detail })
      })
      .finally(() => {
        isLoading.value = false
      })
  }
  return {
    data,
    isLoading,
    readInstagramHashTagSetting,
  }
}
